import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 80px 0px 88px 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--blanco);
  border-top: 1px solid var(--gris80);

`;

export default Container;
